<template>
  <div className="body" id="mainInstance" ref="body">
    <div v-if="loading">
      <v-skeleton-loader
          className="mx-auto"
          type="table"
      ></v-skeleton-loader>
    </div>
    <div v-else>
      <collapsed-table v-bind:items="tableData"
                       v-on:get_children="getChildren"
                       v-on:close_children="closeChildren"
                       v-on:open_children="openChildren"
                       v-bind:accountProperties="accountPropsToTable"></collapsed-table>
    </div>
  </div>
</template>

<script>
import {VSkeletonLoader} from 'vuetify/lib'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faPlus, faMinus, faCalendarAlt} from '@fortawesome/free-solid-svg-icons' //icon-cog, icon-envelope-o,icon-unlock-alt
import Layer0 from '../../extend_classes/Layer0';
import CollapsedTable from './assets/CollapsedTable'
// import moment from "moment";
import _ from "lodash";

library.add(faPlus, faMinus, faCalendarAlt);

const i18n = new window.VueI18n({
  locale: 'en-US', // set locale
  fallbackLocale: 'en-US',
  messages: {
    "en-US": {
      "message": {
        "records_per_page": "records per page",
        "type_to_filter": "Type to Filter...",
        "showing_entires": "Showing {n1} to {n2} of {n3} entries",
        "show_details": "Show details",
        "hide_details": "Hide details",
        "ok": "OK",
        "cancel": "Cancel",
        "edit": "EDIT",
        "select": "Please select",
        "enter": "Enter",
        "empty": "no records to show",
      }
    }
  }

});
export default {
  name: 'frontline-invoices',
  i18n: i18n,
  extends: Layer0,
  components: {
    VSkeletonLoader,
    CollapsedTable,
    // OnlineOrderHistory
  },
  props: {
    accountProperties: {
      default: '[]',
      required: false,
      type: String
    },
    accountsFilter: {
      default: '',
      required: false,
      type: String,
    },
    ...Layer0.props
  },
  data: function () {
    return {
      loc_name: 'VFrontline',
      accountPropsList: [],
      accountPropsToTable: [['title', 'title'], ['firstName', 'firstName'], ['lastName', 'lastName']],
      tableData: [],
      paramsQuery: '',
      maskAccountId: s => s,
    }
  },
  created() {
  },
  mounted() {
    if (!window.MLMSoftUICore)
      window.addEventListener('singletonCreated', () => {
        this.maskAccountId = window.MLMSoftUICore.formatAccountId;
      });
    else {
      this.maskAccountId = window.MLMSoftUICore.formatAccountId;
    }
  },
  methods: {
    async getInfo() {
      try {
          await this.store.dispatch('getLocalizationModule', {module: 'Api2Middleware', i18n, customLocalization: '/user/themes/monarch/images/localization_core/core.txt', UIProxyLoc: JSON.parse(JSON.stringify(i18n._vm.messages))});
      } catch (error) {
          console.log('-------------------------------')
          console.log('error', error)
      }

      this.loading = true;
      let aid = this.accountId;
      if (!aid)
        aid = await this.store.dispatch('getAccountId');
      try {
        this.accountPropsList = JSON.parse(this.accountProperties);
        if (!Array.isArray(this.accountPropsList))
          this.accountPropsList = []
      } catch (e) {
        console.log('e', e)
        this.accountPropsList = []
      }

      this.store.dispatch('getPropsLocalization')
      this.accountPropsList.forEach((apl) => this.accountPropsToTable.push([apl, apl]))
      this.accountPropsToTable = this.accountPropsToTable.map((item) => {
        let loc = i18n.t('properties.' + item[0])

        if (loc && loc != 'properties.' + item[0]) {
            item[1] = loc
        } else {
          this.store.state.locProps.forEach((l) => {
            if (item[0] === l.alias) {
              if (/ru-RU/.test(window.location.href)) {
                item[1] = l['ru-RU']
              } else {
                item[1] = l['en-US']
              }
            }
          })
        }
 
        return item
      })

      this.accountPropsList.map((item, key) => {
        this.paramsQuery += `&properties[${key}]=${item}`
      })

      let filterLine = ``;
      if(this.accountsFilter.length > 0) {
        const accountsFilterArray = JSON.parse(this.accountsFilter)

        if(typeof accountsFilterArray !== 'undefined' && accountsFilterArray.length > 0) {
          accountsFilterArray.map((item,index) => {
            console.log('item', item)
            filterLine += `&filter[${index}][field]=${encodeURIComponent(item[0])}&filter[${index}][operation]=${encodeURIComponent(item[1])}&filter[${index}][value]=${encodeURIComponent(item[2])}`;
          });
        }
      }

      await this.store.dispatch('requestApi3', {
        path: `account/${aid}/downline?withAccounts=true&depth=1&treeId=0${this.paramsQuery}${filterLine}`,
        method: 'get'
      }).then(async response => {
        
        response.data.payload.list.map(item => {
          if(item.accountId != aid) {
            let tdItem = {
              id: item.accountId,
              idM: this.maskAccountId(item.accountId.toString()),
              childrenNum: item.hasChild,
              title: item.account?.title,
              firstName: item.account?.users[0]?.firstName,
              lastName: item.account?.users[0]?.lastName,
              open: false,
              loaded: false,
              children: [],
              treeLevel: item.treeLevel
            }
            item.properties.map(pItem => {
              tdItem[pItem.alias] = pItem.value.presentable
            })
            this.tableData.push(tdItem)
          }
        })
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.loading = false
      })

    },
    async closeChildren(id) {
      let searchRes = _(this.tableData)
          .thru(function(coll) {
            return _.union(coll, _.map(coll, 'children') || []);
          })
          .flatten()
          .find({ id: id });

      searchRes.open = false
    },
    async openChildren(id) {
      let searchRes = _(this.tableData)
          .thru(function(coll) {
            return _.union(coll, _.map(coll, 'children') || []);
          })
          .flatten()
          .find({ id: id });

      searchRes.open = true
    },
    async getChildren(id) {
        // await this.store.dispatch('request', {
        //   path: `api2/main-app/account/get-invoice?accountId=${id}`,
        //   method: 'get'
        // }).then(response => {
        //   console.log(response)
        //
        //   let childrenArray = []
        //   response.data.primary.payload.list.map(item => {
        //     let d = moment(item.createdAt)
        //
        //     let tdItem = {
        //       id: item.id,
        //       date: d.format('YYYY-MM-DD HH:mm:ss'),
        //       accoutId: item.accountId,
        //       status: item.status,
        //       payment_system: item.paymentSystem.title,
        //       wallet: item.wallet.title,
        //       amount: item.buyerAmount,
        //       comission: item.Commission,
        //       paind_at: item.paidAt,
        //       comment: item.comment
        //     }
        //     childrenArray.push(tdItem)
        // })
        //
        let searchRes = this.tableData.filter(itm => itm.id === id)
        //
        // console.log('rr', searchRes)
        searchRes[0].open = true
        // searchRes[0].loaded = true
        // searchRes[0].children = childrenArray
      // }).catch(e => {
      //   console.log(e)
      // }).finally(() => {
      //   this.loadingSub = false
      // })

    }

  }
}
</script>
<style lang="scss" scoped>


</style>
<style scoped>
@import '~vuetify/dist/vuetify.min.css';
@import './../../styles/projectStyles/vuetify/vuetify-del.css';
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '~bootstrap/dist/css/bootstrap-grid.min.css';
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import "./../../styles/monarch/elements/forms.css";
@import "./../../styles/monarch/helpers/boilerplate.css";
@import "./../../styles/monarch/helpers/utils.css";
@import "./../../styles/monarch/helpers/typography.css";
/*@import "./../../styles/monarch/helpers/grid.css";*/
@import "./../../styles/monarch/widgets/touchspin/touchspin.css";
@import "./../../styles/monarch/widgets/datatable/datatable.css";
@import "./../../styles/monarch/helpers/border-radius.css";
@import "./../../styles/monarch/elements/content-box.css";
@import "./../../styles/monarch/elements/social-box.css";
@import "./../../styles/monarch/elements/images.css";
@import "./../../styles/monarch/themes/admin/color-schemes/default.css";
@import "./../../styles/monarch/elements/buttons.css";
@import "./../../styles/monarch/helpers/colors.css";
@import "./../../styles/projectStyles/table/striped.css";
@import "./../../styles/monarch/icons/fontawesome/fontawesome.css";

</style>
